import Addicon from "@mui/icons-material/Add";
import { Divider, Box, CircularProgress } from "@mui/material";

import Summary from "../components/Summary";
import useJStyles from "$hooks/useJStyles";
import JTooltip from "$components/JTooltip/JTooltip";
import { EDB_IS_DISABLED_MSG } from "../../constants";
import { useStyles } from "../styles/ProfileEDB.styles";
import ProductForm from "../../../Products/ProductForm";
import { useProfileEDBContext } from "../context/ProfileEDBContext";
import { Text, Table, Button as LocalButton, Popin } from "$components";
import OrdersAndReceptions from "../../OrdersAndReceptions/OrdersAndReceptions";
import { useStyles as useEDBProfileClasses } from "$containers/EDB/styles/EdbProfile.Styles";
import OPList from "../components/OPList";

export default function AdminTab() {
  const classes = useStyles();
  const { jclasses } = useJStyles();
  const edbClasses = useEDBProfileClasses();

  const {
    edb,
    canCreateOp,
    tInfoHeader,
    tInfoData,
    integratedOrders,
    isLoading,

    // Functions
    fetchIntegratedOrders,
    handleCreateOP,
    fetchEdb,
    formOpen,
    togglePopin,
    onSubmit,
    isCreatingOp,
    isDisabled,
  } = useProfileEDBContext();

  if (isLoading || !edb) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="200px"
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <>
      <Summary />

      <Box className={classes.iOrdersAndReceptions}>
        <OrdersAndReceptions
          fetchIntegratedOrders={fetchIntegratedOrders}
          integratedOrders={integratedOrders}
          isDisabled={isDisabled}
          edb={edb}
          fetchEdb={fetchEdb}
        />
      </Box>

      <Divider className={edbClasses.divider} />

      <div className={edbClasses.informations}>
        <div className={edbClasses.informationsHeader}>
          <Text type="h3" className={edbClasses.informationsTitle}>
            Suivi de l&apos;expression de besoin
          </Text>
          <JTooltip title={isDisabled && EDB_IS_DISABLED_MSG}>
            <LocalButton
              startIcon={<Addicon />}
              disabled={!canCreateOp}
              onClick={() => handleCreateOP()}
              style={{ marginBottom: 10 }}
            >
              {isCreatingOp ? <CircularProgress size={24} /> : "Créer les OP"}
            </LocalButton>
          </JTooltip>
        </div>
        <div className={jclasses.scrollTable}>
          <div className={jclasses.scrollTableXL}>
            <Table
              className={classes.products}
              rowsPerPage={1000}
              thead={tInfoHeader}
              bodyData={tInfoData}
            />
          </div>
        </div>
      </div>

      <OPList />

      <Popin
        className={classes.CreateEdbPage_Popin}
        openPopin={formOpen}
        toggleDrawer={() => togglePopin(false)}
      >
        <Text type="h2">Produit hors catalogue</Text>
        <ProductForm
          // product={} TODO : Récupérer le produit pour le passer
          onSubmit={onSubmit}
          onReset={() => togglePopin(false)}
          company={edb?.company._id}
        />
      </Popin>
    </>
  );
}
